import { getWindowData } from 'owa-window-data';

export function isPwa(): boolean {
    return getWindowData().isPwa;
}
